import React, { useState } from "react";
import DebtReportItem from "./DebtReportItem";
import { v4 as uuid } from "uuid";
import { Stack } from "@mui/material";
import { REPORT_TYPE } from "../const/constants";
import DebtReportConfirmPopup from "./DebtReportConfirmPopup";

export const debtReportList = [
  {
    id: uuid(),
    title: "Báo cáo chi tiết tồn kho",
    description: `Quản lý số lượng tồn kho theo từng sản phẩm, từng\nkho riêng biệt`,
    type: REPORT_TYPE.INVENTORY_DETAIL,
  },
  {
    id: uuid(),
    title: "Báo cáo tồn kho dưới định mức",
    description: `Quản lý số lượng tồn kho các sản phẩm dưới định\nmức số lượng để đặt hàng sản xuất`,
    type: REPORT_TYPE.INVENTORY_WARNING,
  },
  {
    id: uuid(),
    title: "Xuất Thông tin Hoá đơn",
    description: `Quản lý số lượng tồn kho theo từng sản phẩm, từng\nkho riêng biệt`,
    type: REPORT_TYPE.ORDER_EXPORT,
  },
  {
    id: uuid(),
    title: "Báo cáo Công nợ phải thu",
    description: `Báo cáo công nợ phải thu khách hàng theo kỳ`,
    type: REPORT_TYPE.DEBT_OUTBOUND,
  },
  {
    id: uuid(),
    title: "Báo cáo xuất nhập tồn sản phẩm",
    description: `Quản lý tồn đầu kỳ, nhập trong kỳ và tồn cuối kỳ\ncủa sản phẩm`,
    type: REPORT_TYPE.INVENTORY,
  },
  {
    id: uuid(),
    title: "Báo cáo Doanh thu",
    description: `Quản lý tồn đầu kỳ, nhập trong kỳ và tồn cuối kỳ\ncủa sản phẩm`,
    type: REPORT_TYPE.INCOME,
  },
];

const DebtReportList = () => {
  const [type, setType] = useState(null);
  const handleClose = () => {
    setType(null);
  };
  const handleClickItem = (type) => {
    setType(type);
  };
  return (
    <Stack
      spacing="18px"
      width="100%"
      s
    >
      {debtReportList.map((item) => (
        <DebtReportItem
          key={item.id}
          item={item}
          onClick={handleClickItem}
        />
      ))}
      <DebtReportConfirmPopup
        open={!!type}
        onClose={handleClose}
        type={type}
      />
    </Stack>
  );
};

export default DebtReportList;
